import styled from "@emotion/styled";

export const Root = styled.img`
  width: 218px;
`